class PostGrid extends HTMLElement {
  constructor() {
    super();
    this.currentPage = 1;
    this.isLoading = false;
    this.hasMorePages = true;
    this.observer = null;
    this.postBlocks = [];
  }

  connectedCallback() {
    // Get data attributes
    this.totalPages = parseInt(this.dataset.paginationPages) || 1;
    this.collectionHandle = this.dataset.collectionHandle;
    setTimeout(() => {
      this.initMasonry();
      this.setupIntersectionObserver();
    }, 100); // Delay to ensure styles are applied
    window.addEventListener("resize", this.initMasonry.bind(this));
  }

  initMasonry() {
    if (!this.postBlocks.length)
      this.postBlocks = Array.from(document.querySelectorAll(".post-block"));
    console.log(this.postBlocks);
    const numColumns = window.innerWidth < 800 ? 1 : 4;
    const columns = Array.from({ length: numColumns }, () => []);

    this.postBlocks.forEach((block, index) => {
      columns[index % numColumns].push(block);
    });

    // Clear existing content
    this.innerHTML = "";

    // Create column containers and append blocks
    columns.forEach((colBlocks) => {
      const colDiv = document.createElement("div");
      colDiv.classList.add("column");
      colBlocks.forEach((block) => colDiv.appendChild(block));
      this.appendChild(colDiv);
    });
  }

  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: "100px",
      threshold: 0.1,
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.isLoading && this.hasMorePages) {
          this.loadNextPage();
        }
      });
    }, options);
    console.log(this.postBlocks);
    this.observer.observe(this.postBlocks[this.postBlocks.length - 1]);
  }

  async loadNextPage() {
    if (this.isLoading || this.currentPage >= this.totalPages) {
      this.hasMorePages = false;
      return;
    }

    this.isLoading = true;

    try {
      const nextPage = this.currentPage + 1;
      const url = new URL(window.location);
      url.searchParams.set("page", nextPage);

      const response = await fetch(url.toString());

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // Find the product grid in the response
      const newPosts = doc.querySelectorAll(".post-block");

      if (newPosts.length === 0) {
        this.hasMorePages = false;
        return;
      }

      this.observer.disconnect();

      // Append new posts to the current grid
      newPosts.forEach((post) => {
        // Clone the node and append it
        const clonedPost = post.cloneNode(true);
        this.postBlocks.push(clonedPost);
      });

      this.observer.observe(this.postBlocks[this.postBlocks.length - 1]);

      // Update current page
      this.currentPage = nextPage;

      // Check if we've reached the last page
      if (nextPage >= this.totalPages) {
        this.hasMorePages = false;
      }
      this.initMasonry();
    } catch (error) {
      console.error("Error loading next page:", error);
      this.hasMorePages = false;
    } finally {
      this.isLoading = false;
    }
  }
}

// Register the custom element
if (!customElements.get("post-grid")) {
  customElements.define("post-grid", PostGrid);
}
